import { DrawerMenu } from 'Components/Layout/DrawerMenu'
import type { NavLinkItem } from 'Components/Layout/DrawerMenu/types'
import MenuBar from 'Components/Layout/MenuBar'
import NotificationBanner from 'Components/NotificationBanner'
import useTypedSelector from 'Store'
import { CONTENT_MAX_WIDTH, DRAWER_WIDTH, IS_WALTTI_SERVICE_ENVIRONMENT } from 'Util/constants'
import { Box } from '@mui/material'
import type React from 'react'
import { Outlet } from 'react-router-dom'

interface DrawerLayoutProps {
  rootUrl: string
  drawerMenuNavLinks?: NavLinkItem[]
  menuBarNavLinks?: NavLinkItem[]
  children?: React.ReactNode
}

const DrawerLayout = ({
  rootUrl,
  drawerMenuNavLinks = [],
  menuBarNavLinks = [],
  children
}: DrawerLayoutProps) => {
  const { authed: isAuthed, user } = useTypedSelector(state => state.user)

  let showNotificationBanner = false
  if (user) {
    // TODO: Backend support missing for Authority notifications for HSL users.
    //  Remove the IS_WALTTI_SERVICE_ENVIRONMENT check if/when backend support is added.
    showNotificationBanner = isAuthed && IS_WALTTI_SERVICE_ENVIRONMENT
  }

  return (
    <Box>
      <MenuBar menuBarNavLinks={menuBarNavLinks} />
      <DrawerMenu drawerMenuNavLinks={drawerMenuNavLinks} rootUrl={rootUrl} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          marginLeft: `${DRAWER_WIDTH}px`,
          width: `calc(100% - ${DRAWER_WIDTH}px)`
        }}
      >
        {showNotificationBanner && (
          <Box
            sx={{
              p: 0,
              width: '100%'
            }}
          >
            <NotificationBanner />
          </Box>
        )}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            width: '100%',
            maxWidth: CONTENT_MAX_WIDTH
          }}
        >
          {children ?? <Outlet />}
        </Box>
      </Box>
    </Box>
  )
}

export { DrawerLayout }
export default DrawerLayout
